export default class FolderDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
